@use "variables" as *;

.content {
  display: flex;
  flex-direction: column;
}

.message {
  font-size: $fontSize-s;
  white-space: pre-wrap;
}

.dropzonePlaceholder {
  font-size: $fontSize-s;
}

.confirmButton {
  margin-top: $spacing-l !important;
  align-self: flex-end;
}

.templateButton {
  margin-bottom: $spacing-l;
  align-self: center;
}
